import React from "react";
import {
  Box,
  Modal,
  Typography,
  Button,
  IconButton,
  Card,
  CardContent,
} from "@mui/material";
import { Close, Payment, Support } from "@mui/icons-material";
import { Icon } from "@iconify/react";
import { useIds } from "../../hook/AdminContext";

export default function UpgradeModal({
  open,
  handleClose,
  islimitExceedModal = false,
}) {
  const { findId, adminSetting } = useIds();

  const handleContactSupport = () => {
    // You can implement contact support functionality here
    // For now, just close the modal
    handleClose();
  };

  const handleUpgrade = () => {
    // You can implement upgrade functionality here
    // For now, just close the modal
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: "900px",
          // height: "auto",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 3,
          p: 2,
          outline: "none",
        }}
      >
        {/* Header with Close Button */}
        <Box
          sx={{
            backgroundColor: "var(--portal-primary-color)",
            color: "white",
            p: 2,
            borderRadius: "12px 12px 0 0",
            position: "relative",
            mb: 1.5,
            mx: -2,
            mt: -2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ textAlign: "start", color: "var(--text-white)" }}
          >
            {islimitExceedModal ? "Limit Exceeded" : "Payment Required"}
          </Typography>
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: "50%",
              transform: "translateY(-50%)",
              color: "white",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.1)",
              },
            }}
          >
            <Close />
          </IconButton>
        </Box>

        {/* Icon and Subtitle */}
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <Box
            sx={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              backgroundColor: "#F5CE6E",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 10px",
              boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
            }}
          >
            <Payment sx={{ fontSize: 30, color: "#fff" }} />
          </Box>
          <Typography
            variant="body1"
            sx={{ color: "text.secondary", fontWeight: 400 }}
          >
            {islimitExceedModal
              ? "You’ve reached your current plan’s limit. Upgrade to continue."
              : "Complete your payment to unlock premium features"}
          </Typography>
        </Box>

        {/* Content */}
        <Card sx={{ mb: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}>
          <CardContent sx={{ p: 1.5 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                mb: 1.5,
                color: "var(--portal-primary-color)",
                textAlign: "center",
              }}
            >
              {islimitExceedModal
                ? "Why upgrade your plan?"
                : "Why is payment required?"}
            </Typography>
            <Typography
              variant="body2"
              sx={{ mb: 1.5, lineHeight: 1.5, fontSize: "14px" }}
            >
              {islimitExceedModal
                ? `You’ve reached the usage limit allowed for your current plan. To
          access more features, increase limits, and continue enjoying seamless
          access, please upgrade to a higher plan that fits your needs.`
                : `To maintain the quality of our platform and provide you with the
              best experience, please use a valid payment method to complete
              your payment and unlock the portal’s premium features. To make a
              payment, go to Payment Requests in your Account options, and
              complete any pending requests.`}
            </Typography>
            <Box sx={{ pl: 1 }}>
              {/* <Typography
                variant="body2"
                sx={{
                  mb: 1,
                  display: "flex",
                  alignItems: "center",
                  fontSize: "13px",
                }}
              >
                •{" "}
                <Icon
                  icon="mdi:check-circle"
                  style={{
                    color: "#4CAF50",
                    marginRight: 8,
                    fontSize: "16px",
                  }}
                />
                Creating posts
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  mb: 1,
                  display: "flex",
                  alignItems: "center",
                  fontSize: "13px",
                }}
              >
                •{" "}
                <Icon
                  icon="mdi:check-circle"
                  style={{
                    color: "#4CAF50",
                    marginRight: 8,
                    fontSize: "16px",
                  }}
                />
                Posting job opportunities
              </Typography> */}
              {/* <Typography
                variant="body2"
                sx={{
                  mb: 1,
                  display: "flex",
                  alignItems: "center",
                  fontSize: "13px",
                }}
              >
                •{" "}
                <Icon
                  icon="mdi:check-circle"
                  style={{
                    color: "#4CAF50",
                    marginRight: 8,
                    fontSize: "16px",
                  }}
                />
                Access to premium content and resources
              </Typography>
              <Typography
                variant="body2"
                sx={{ display: "flex", alignItems: "center", fontSize: "13px" }}
              >
                •{" "}
                <Icon
                  icon="mdi:check-circle"
                  style={{
                    color: "#4CAF50",
                    marginRight: 8,
                    fontSize: "16px",
                  }}
                />
                Advanced networking and collaboration features
              </Typography> */}
            </Box>
          </CardContent>
        </Card>

        {/* Action Buttons */}

        {/* Contact Email */}
        {adminSetting?.contact_us_support_email_for_website && (
          <Box sx={{ textAlign: "center", mb: 1 }}>
            <Typography
              variant="body2"
              sx={{
                color: "var(--portal-primary-color)",
                fontWeight: 500,
                fontSize: "13px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 0.5,
              }}
            >
              <Support sx={{ fontSize: 16 }} />
              Contact us at:{" "}
              <span style={{ fontWeight: 600 }}>
                {adminSetting.contact_us_support_email_for_website}
              </span>
            </Typography>
          </Box>
        )}

        {/* Footer Text */}
        <Typography
          variant="caption"
          sx={{
            display: "block",
            textAlign: "center",
            mt: 1,
            color: "text.secondary",
            fontStyle: "italic",
            fontSize: "11px",
          }}
        >
          Need help? Our support team is available 24/7 to assist you
        </Typography>
      </Box>
    </Modal>
  );
}
